import type Rollbar from 'rollbar';

export class GlobalLogger {
  static log(...args: unknown[]) {
    console.log(...args);
  }

  static warn(...args: unknown[]) {
    (window.Rollbar ?? console).warn(...(args as Rollbar.LogArgument[]));
  }

  static error(...args: unknown[]) {
    (window.Rollbar ?? console).error(...(args as Rollbar.LogArgument[]));
  }
}
